module.exports = __webpack_public_path__ + "static/media/orbit.67a76042.png";